<template>
    <div class="text-white flex flex-row items-center">
        <div class="flex gap-2">
            <i class="fas fa-envelope cursor-pointer hover:text-gray-300"></i>
            <i class="fas fa-sign-out-alt cursor-pointer hover:text-gray-300" @click="logout"></i>
        </div>
        <div class="flex justify-center items-center">
            <div class="text-3xl font-thin"><i class="fa-solid fa-circle-user"></i></div>
            <div class="flex flex-col">
                <h3 class="text-sm capitalize">{{ user.nome }}</h3>
            </div>
        </div>
    </div>
</template>
<script>

import AppSearch from '@/components/search.vue'
import axios from 'axios';

export default {
    name: 'AppProfileSearch',
    components: {
        AppSearch,
    },
    props: {
        show: {
            type: Boolean,
            default: () => false
        },
        search_data: {
            type: Array,
            default: () => []
        },
      
    },
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user')),
            baseUrl: process.env.VUE_APP_URL_BASE,       
        }
    },
    methods: {
        async logout() {
            
            try {
                const res = await axios.post(`${this.baseUrl}/api/v1/logout/${this.user.id}/`)
                .then(response => {
                    console.log('Logout:', response)
                })
            } catch (error) {
                console.log('Erro ao fazer logout:', error)
            }
            this.$router.push({ name: 'signin' })
            localStorage.clear()

        },
        search_OnClick(content) {
            console.log(content)
            this.$emit('search-clicked', content)
        },
    }
}
</script>